import React from "react";
import ButtonClose from "../../../ui/shared/ButtonClose/ButtonClose";

export interface TransferAlertProps {
  containerClassName?: string;
  type?: "default" | "warning" | "info" | "success" | "error";
  children: React.ReactNode;
  closable?: boolean;
  className?: string;
  onClose?: () => void;
}

export const TransferAlert: React.FC<TransferAlertProps> = ({
  children = "Alert Text",
  containerClassName = "",
  type = "default",
  closable = true,
  className,
  onClose,
}) => {
  let classes = containerClassName;
  switch (type) {
    case "default":
      classes += " text-black bg-neutral-900";
      break;
    case "info":
      classes += " bg-blue-200 text-blue-900";
      break;
    case "success":
      classes += " bg-green-200 text-green-900";
      break;
    case "error":
      classes += " bg-red-200 text-red-900";
      break;
    case "warning":
      classes += " bg-orange-200 text-orange-900";
      break;
    default:
      break;
  }

  // Render children with support for line breaks (\n)
  const renderContent = () => {
    if (typeof children === 'string' && children.includes('\n')) {
      return (
        <div className="flex flex-col gap-3">
          {children.split('\n').map((line, index) => (
            <div key={index} className="leading-relaxed">{line}</div>
          ))}
        </div>
      );
    }
    return children;
  };

  return (
    <div
      className={`ttnc-alert relative flex items-start text-paragraph-base px-6 pt-4 pb-3 rounded-lg ${classes} ${className}`}
    >
      <i className="pe-7s-info text-2xl mr-2 flex-shrink-0 mt-1"></i>
      <div className="flex-1">
        {renderContent()}
      </div>
      {closable && <ButtonClose onClick={onClose} className="absolute top-4 right-6" />}
    </div>
  );
};

export default TransferAlert;

